import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UserProfileService } from '@app/modules/core/services/user-profile.service';
import { DocumentReader } from 'src/app/modules/core/store/models';

@Component({
    selector: 'app-business-units-cell',
    templateUrl: './business-units-cell.component.html',
    styleUrls: ['./business-units-cell.component.scss'],
    standalone: false
})
export class BusinessUnitsCellComponent implements OnInit {
  value: any;

  constructor(
    private changeDetector: ChangeDetectorRef,
    private userProfileService: UserProfileService
  ) {}

  ngOnInit(): void {}

  agInit(params: any): void {
    const document = params.data;
    const field = params.schemaField;
    const reader = new DocumentReader(document);
    const selectedValues = !!params.data ? reader.getFieldValue(field.systemName) : params.value;
    this.value = '';

    if (this.userProfileService.getUserHasBusinessUnits()) {
      const businessUnits = this.userProfileService.getUserBusinessUnits();

      selectedValues?.map(val => {
        const selectedItem = businessUnits?.find(bu => bu.uId === val);
        if (!!selectedItem) {
          this.value += this.value.length > 0 ? `, ${selectedItem.name}` : selectedItem.name;
        }
      });
    }
    this.changeDetector.markForCheck();
  }
}
